<template>
    <div class="row">
        <div class="col-12 mb-3">
            <table>
              <thead>
                <th>Cube/Shop</th>
                <th>Status</th>
                <th>Last stage</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr v-for="single in task" :key="single.id" :class="single.lastStatus">
                  <td>{{single.cube || single.context}}</td>
                  <td>{{single.lastStatus}}</td>
                  <td>{{single.stages[single.stages.length-1] && single.stages[single.stages.length-1].message || "-"}}</td>
                  <td>
                    <el-button
                    size="mini"
                    v-if="single.lastStatus == 'BUSY' || 
                    single.lastStatus == 'TO_RUN' || 
                    single.lastStatus == 'UPDATE_PROBLEM_NO_DONE' || 
                    single.lastStatus == 'UPDATE_PROBLEM_NO_STATUS'"
                    @click="runTask(single.id)">Run</el-button>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>  
            </table>
        </div>
    </div>
</template>


<script>
  //import 'codemirror/lib/codemirror.css';
  import _ from 'underscore';

  import { mapActions, mapGetters, mapMutations } from 'vuex'

  export default {
    components: {

    },
    data(){
        return { 

        }
    },
    props: {
        task: {
            default: {}
        }
    },
    methods: {
       ...mapActions([
        'getUserTasksAsync',
        'runTaskAsync',
      ]),
      runTask(id){
        this.runTaskAsync(id)
      }
    },
    async created(){
    },
    computed: {

    }
  };
</script> 

<style lang="scss">

table { 
  width: 100%;
}
</style>